import { useEffect } from "react";
import { buildClientTokenContext } from "@/contexts/clientAccessTokenContext";
import { useGetClientIdByTokenQuery } from "@/graphql/queries/getClientIdByToken.graphql.types";
import { useMedspaIdQuery } from "@/graphql/queries/medspaId.graphql.types";
import { Datadog } from "@/utils/observability/datadog";

export default function useTrackClient({
  clientAccessToken,
  medspaSlug,
  isClientPage,
}: {
  clientAccessToken: string;
  medspaSlug: string;
  isClientPage: boolean;
}) {
  const { data: clientData } = useGetClientIdByTokenQuery({
    variables: {
      token: clientAccessToken,
    },
    skip: !isClientPage || !clientAccessToken,
    fetchPolicy: "cache-first",
    context: buildClientTokenContext(clientAccessToken),
  });
  const { data: medspaData } = useMedspaIdQuery({
    variables: {
      slug: medspaSlug,
    },
    skip: !isClientPage,
    fetchPolicy: "cache-first",
    context: { noAuth: true },
  });
  const client = clientData?.clientAccessTokenByPk?.client;
  const medspaId = medspaData?.medspa?.[0]?.id;

  useEffect(() => {
    if (!isClientPage) {
      return;
    }
    if (client) {
      Datadog.setUser({
        id: `client_${client.id}`,
        role: "client",
        medspa_id: medspaId,
      });
    } else if (medspaId) {
      Datadog.clearUser();
      Datadog.setMedspaId(medspaId);
    } else {
      Datadog.clearUser();
    }
  }, [client, medspaId, isClientPage]);
}
